import React from "react";
import { CodeBlock } from "react-code-blocks";
import hljs from "highlight.js";

interface CodeRendererProps {
  code: string | null;
}

const languageArray = [
  "javascript",
  "typescript",
  "jsx",
  "python",
  "java",
  "c",
  "cpp",
  "csharp",
  "go",
  "dart",
  "php",
  "ruby",
  "swift",
  "kotlin",
  "sql",
  "html",
  "css",
  "json",
  "bash",
  "shell",
  "yaml",
  "xml",
  "perl",
  "r",
  "rust",
];

const CodeRenderer: React.FC<CodeRendererProps> = ({ code }) => {
  const detectLanguage = (code: string) => {
    const result = hljs.highlightAuto(code, languageArray);
    return result.language;
  };

  return (
    <div style={{padding: "20px",}}>
      <CodeBlock
        text={code ? code : "No answer provided"}
        language={code ? detectLanguage(code) : "plaintext"}
        showLineNumbers={true}
        theme={"light"}
        customStyle={{
          height: "200px",
          overflow: "scroll",
        }}
      />
    </div>
  );
};

export default CodeRenderer;
